import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getStandards } from 'helpers/standards';
import { useAction } from 'hooks';
import Account from 'modules/Account';
import { MobileLoaderLayout } from 'modules/Layout';
import * as actions from '../../../actions';
const PatientProfileMigration = ({ enrollCode, invitationCode })=>{
    const countrySettings = useSelector(Account.selectors.countrySettings);
    const patientSetup = useAction(actions.patientSetup);
    const standards = getStandards(null, countrySettings);
    useEffect(()=>{
        patientSetup({
            createPatientValues: {},
            standards,
            enrollCode,
            invitationCode
        });
    }, []);
    return /*#__PURE__*/ _jsx(MobileLoaderLayout, {});
};
export default PatientProfileMigration;
